module.exports = __webpack_public_path__ + "static/img/step-06.73d4a5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-06.png
// module id = jvtj
// module chunks = 1